// extracted by mini-css-extract-plugin
export default {"bulkActionsContainer":"SNb78Tt5QH7axBAT1Lle","selectedItemsDetails":"f4v3TekEN5mQ5PhgYUcE","bulkActionsButtonGroup":"p7oq56s9VwXkQ4fIJD4z"};